import createModel from "../createModel";
import { PensionFundAndPercentage } from "./PensionFundAndPercentage";

export const PensionFundsChange = createModel("PensionFundsChange", (json) => ({
    effectiveDate: json.EffectiveDate,
    newPensionFunds: PensionFundAndPercentage.fromServerList(json.NewPensionFunds),
    newInvestmentStrategyFunds: PensionFundAndPercentage.fromServerList(json.NewInvestmentStrategyFunds),
}));
